// Owner: performance-closure (plan §10.2). The enumerations that route files validate their URL
// search with (`validateSearch`), kept in a module with no imports: a route's search schema loads with
// the app's route tree on first paint, so it must not pull the schema module of its whole feature
// (zod objects of the inbox, signatures, run explorer, scheduling, Library). The feature modules
// import these arrays from here and re-export them under their old names.

/** Inbox tabs: For you (mine, claimable by me, awaiting my review) · Updates (notifications) · Done. */
export const INBOX_VIEWS = ['for-you', 'updates', 'done'] as const;
/**
 * The tabs "Team" and "Watching" of earlier versions are the assignee filter now ("my team", "watching"):
 * links, API clients and saved views that still name them read as For you with that assignee.
 */
export const LEGACY_INBOX_TABS = ['team', 'watching'] as const;

export const SIGNATURE_LIST_SCOPES = ['todo', 'waiting', 'done', 'all'] as const;
export const BOOKING_LIST_SCOPES = ['upcoming', 'past', 'cancelled', 'all'] as const;
export const RUN_STATUSES = ['queued', 'running', 'waiting', 'succeeded', 'failed', 'cancelled'] as const;

export const WORKFLOW_TABS = ['all', 'live', 'drafts', 'paused', 'failing'] as const;

/**
 * What the Library lists: folders and the artefacts of plan §7.3 `ArtefactRef` minus record
 * interfaces and forms.
 */
export const LIBRARY_KINDS = ['folder', 'page', 'deck', 'document_template', 'dashboard'] as const;
export const LIBRARY_SORTS = ['relevance', 'updated', 'created', 'title', 'opened', 'manual'] as const;
/**
 * The spaces of the Library rail: `all` (search scope), `favourites`, `recent`, `shared`, `mine`,
 * `workspace`, `records` (pages linked to a record) and `trash`.
 */
export const LIBRARY_SPACES = [
  'all',
  'favourites',
  'recent',
  'shared',
  'mine',
  'workspace',
  'records',
  'trash',
] as const;
